import { render, staticRenderFns } from "./tpv-ma-general.vue?vue&type=template&id=5eea0692&scoped=true"
import script from "./tpv-ma-general.vue?vue&type=script&lang=js"
export * from "./tpv-ma-general.vue?vue&type=script&lang=js"
import style0 from "./tpv-ma-general.vue?vue&type=style&index=0&id=5eea0692&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eea0692",
  null
  
)

export default component.exports